/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJSON } from './GeoJSON';
import {
    GeoJSONFromJSON,
    GeoJSONFromJSONTyped,
    GeoJSONToJSON,
} from './GeoJSON';
import type { ShipType } from './ShipType';
import {
    ShipTypeFromJSON,
    ShipTypeFromJSONTyped,
    ShipTypeToJSON,
} from './ShipType';
import type { WatchdogEventEvent } from './WatchdogEventEvent';
import {
    WatchdogEventEventFromJSON,
    WatchdogEventEventFromJSONTyped,
    WatchdogEventEventToJSON,
} from './WatchdogEventEvent';
import type { WatchdogEventWatchdog } from './WatchdogEventWatchdog';
import {
    WatchdogEventWatchdogFromJSON,
    WatchdogEventWatchdogFromJSONTyped,
    WatchdogEventWatchdogToJSON,
} from './WatchdogEventWatchdog';

/**
 * 
 * @export
 * @interface WatchdogEvent
 */
export interface WatchdogEvent {
    /**
     * 
     * @type {WatchdogEventEvent}
     * @memberof WatchdogEvent
     */
    event?: WatchdogEventEvent;
    /**
     * 
     * @type {ShipType}
     * @memberof WatchdogEvent
     */
    ship?: ShipType;
    /**
     * 
     * @type {WatchdogEventWatchdog}
     * @memberof WatchdogEvent
     */
    watchdog?: WatchdogEventWatchdog;
    /**
     * 
     * @type {GeoJSON}
     * @memberof WatchdogEvent
     */
    activated?: GeoJSON;
    /**
     * 
     * @type {GeoJSON}
     * @memberof WatchdogEvent
     */
    deactivated?: GeoJSON;
}

/**
 * Check if a given object implements the WatchdogEvent interface.
 */
export function instanceOfWatchdogEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogEventFromJSON(json: any): WatchdogEvent {
    return WatchdogEventFromJSONTyped(json, false);
}

export function WatchdogEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event': !exists(json, 'event') ? undefined : WatchdogEventEventFromJSON(json['event']),
        'ship': !exists(json, 'ship') ? undefined : ShipTypeFromJSON(json['ship']),
        'watchdog': !exists(json, 'watchdog') ? undefined : WatchdogEventWatchdogFromJSON(json['watchdog']),
        'activated': !exists(json, 'activated') ? undefined : GeoJSONFromJSON(json['activated']),
        'deactivated': !exists(json, 'deactivated') ? undefined : GeoJSONFromJSON(json['deactivated']),
    };
}

export function WatchdogEventToJSON(value?: WatchdogEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event': WatchdogEventEventToJSON(value.event),
        'ship': ShipTypeToJSON(value.ship),
        'watchdog': WatchdogEventWatchdogToJSON(value.watchdog),
        'activated': GeoJSONToJSON(value.activated),
        'deactivated': GeoJSONToJSON(value.deactivated),
    };
}

